import { nextTick } from 'vue';
import { toPng } from 'html-to-image';

// Screenshot do container da matriz de risco para embutir no PDF da avaliação.
// Devolve string vazia quando não há matriz renderizada — o relatório sai sem a
// seção em vez de falhar.
export async function captureMatrixPng(elementId) {
    const element = document.getElementById(elementId);

    if (!element || !element.scrollWidth || !element.scrollHeight) {
        return '';
    }

    try {
        await nextTick();
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));

        return await toPng(element, {
            backgroundColor: '#ffffff',
            cacheBust: true,
            pixelRatio: 2,
            width: element.scrollWidth,
            height: element.scrollHeight,
            canvasWidth: element.scrollWidth * 2,
            canvasHeight: element.scrollHeight * 2,
        });
    } catch (err) {
        return '';
    }
}

export default { captureMatrixPng };
